'use strict';

angular.module('mean.general-tasks').controller('MaterialsController', ['$scope', 'Global', 'Menus', '$rootScope', '$http', 'Materials', 'Units', '$filter', 'tradeCodeService',
    function($scope, Global, Menus, $rootScope, $http, Materials, Units, $filter, tradeCodeService) {
      
      $scope.global = Global;

      $scope.hasAuthorization = function(material) {
        if (!material || !material.user) return false;
        return $scope.global.isAdmin || material.user._id === $scope.global.user._id;
      };

      var data;
      $scope.suppliers = [];

      $scope.deleteAllInTrade = function(trade) {
        var temp_list = $filter('filter')($scope.materials, {'trade': trade}, true);
          temp_list.forEach(function(list) {
            list.$delete();
          });
      };

      $scope.init = function() {
        Materials.query({}, function(materials) {
          $scope.materials = materials;

          //$scope.deleteAllInTrade('13');

          $scope.units = Units.query();

          $scope.materials.forEach(function(material, idx) {
            var supplier = material.supplier;
            if(supplier) {
              var in_list = $filter('filter')($scope.suppliers, {name: supplier, trade: material.trade, category: material.category});

              //is the supplier in the list?
              if(in_list.length === 0) {
                $scope.suppliers.push({
                  name: supplier,
                  trade: material.trade,
                  category: material.category
                });
              }
            }
          });
        });
      };

      $scope.onSelect = function() {
        if($scope.selectedItem) {
          data = $filter('filter')($scope.materials, { trade: $scope.selectedItem });
        } else {
          data = $scope.materials;
        }

        if($scope.supplier) {
          data = $filter('filter')(data, { supplier: $scope.supplier.name });
        }

        if($scope.category && $scope.supplier) {
          data = $filter('filter')(data, { category: $scope.category.category });
        }

        $scope.tableMaterialsParams.total(data.length);
        $scope.tableMaterialsParams.reload();
      };

      $scope.addMaterial = function() {
          if (!$scope.materials) $scope.materials = [];

          if(!$scope.add_name) {
            alert('You must specify a material name');
            return;
          }

          if(!$scope.add_trade) {
            alert('You must specify a trade for this material');
            return;
          }

          if(!$scope.add_unit) {
            alert('You must specify a Unit of Measure.');
            return;
          }

          if(!$scope.add_delivery_offset) {
            $scope.add_delivery_offset = 'Same Day';
            console.log('had to set the delivery offset');
          }

          var material = new Materials({
              name: $scope.add_name,
              description: $scope.add_description,
              trade: $scope.add_trade,
              units_per_order: $scope.add_units_per_order,
              price_per_order: $scope.add_price_per_order,
              delivery_price: $scope.add_delivery_price,
              piece_per_size: $scope.add_piece_per_size,
              unit: $scope.add_unit._id,
              delivery_offset: $scope.add_delivery_offset,
              supplier: $scope.add_supplier,
              category: $scope.add_category
          });



          material.$save(function(response) {
              $scope.materials.push(response);

              $scope.materials.forEach(function(material, idx) {
                var supplier = material.supplier;
                if(supplier) {
                  var in_list = $filter('filter')($scope.suppliers, {name: supplier, trade: material.trade, category: material.category});

                  //is the supplier in the list?
                  if(in_list.length === 0) {
                    $scope.suppliers.push({
                      name: supplier,
                      trade: material.trade,
                      category: material.category
                    });
                  }
                }
              });

              data = $scope.materials;
              $scope.tableMaterialsParams.total(data.length);
              $scope.tableMaterialsParams.reload();
          });

          this.add_name = 
          this.add_description = 
          this.add_trade =
          this.add_units_per_order =
          this.add_price_per_order =
          this.add_delivery_price =
          this.add_piece_per_size = 
          this.add_unit = 
          this.add_delivery_offset = 
          this.add_supplier =
          this.add_category = '';
      };

      $scope.remove = function(material) {
          for (var i in $scope.materials) {
              if ($scope.materials[i] === material) {
                  $scope.materials.splice(i, 1);
              }
          }

          material.$remove();
          data = $scope.materials;
          $scope.tableMaterialsParams.total(data.length);
          $scope.tableMaterialsParams.reload();
      };

      $scope.update = function(material, materialField) {
        //material.unit = material.unit._id;
          //console.log('in the update function' + material.unit);
        material.$update();
        $scope.materialsEditId = -1;
        data = $scope.materials;
        $scope.tableMaterialsParams.total(data.length);
        $scope.tableMaterialsParams.reload();
      };

      $scope.setMaterialsEditId =  function(pid) {
          $scope.materialsEditId = pid;
      };

      $scope.getTradeName = function(id) {
        return tradeCodeService.getName(id);
      };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/general-tasks/public/controllers/materials.js